module.exports = __webpack_public_path__ + "static/image/sign/kimbeomjun@2x.png?059e96a2";